import Covidtable from "../../../../content/posts/2020-06-05-covid19-in-headline/Covidtable.js";
import React from 'react';
export default {
  Covidtable,
  React
};